import { IIconProps } from '../../types/IconProps.interface'

export const IconPlay = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.8113 6.41155C14.0681 7.1039 14.0681 8.8961 12.8113 9.58844L5.22263 13.7687C4.00112 14.4416 2.5 13.5658 2.5 12.1803V3.81974C2.5 2.43421 4.00112 1.55841 5.22262 2.23129L12.8113 6.41155Z'
        stroke={color}
      />
    </svg>
  )
}
